import * as React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import type { TourIntroDef, TourMedia } from "./types";

type Props = {
  open: boolean;
  intro: TourIntroDef | null;
  onContinue: () => void;
  onSkip: () => void;
};

function IntroMedia({ media }: { media?: TourMedia }) {
  if (!media?.src) return null;
  return (
    <div className="ew-product-tour-intro__media">
      <img
        src={media.src}
        alt=""
        className="ew-product-tour-intro__media-img"
        data-media-type={media.type}
      />
    </div>
  );
}

export default function ProductTourIntro({
  open,
  intro,
  onContinue,
  onSkip,
}: Props) {
  const { t } = useTranslation("productTour");
  if (!intro) return null;

  return (
    <Modal
      show={open}
      onHide={onSkip}
      centered
      dialogClassName="ew-product-tour-intro__dialog"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="ew-product-tour-intro">
        <IntroMedia media={intro.media} />
        <h2 className="ew-product-tour-intro__title">{t(intro.titleKey)}</h2>
        {intro.bodyKeys.map((key) => (
          <p key={key} className="ew-product-tour-intro__body">
            {t(key)}
          </p>
        ))}
        <div className="ew-product-tour-intro__actions">
          <button
            type="button"
            className="ew-product-tour__cta"
            onClick={onContinue}
          >
            {t("common.continue")}
          </button>
          <button
            type="button"
            className="ew-product-tour__skip"
            onClick={onSkip}
          >
            {t("common.skip")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
